/**
 * VideoPlayer
 * @description Wrapper around video, with click to play interaction.
 */
class VideoPlayer extends HTMLElement {
  constructor() {

    super();
    this.element = this;
    this.videoDesktop = this.querySelector('[data-video]');
    this.source = this.videoDesktop.querySelector('source');

    // Check for video click events
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.videoDesktop.paused === true) {
        this.videoDesktop.play();
        this.element.classList.add('playing');
      }
      else {
        this.videoDesktop.pause();
        this.element.classList.remove('playing');
      }
    });

    // Remove play state class from element when the video is done.
    this.videoDesktop?.addEventListener('ended', () => {
      this.element.classList.remove('playing');
    });
  }

}

if(!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}